import { render, staticRenderFns } from "./quick-questionsView.vue?vue&type=template&id=7d271b2f&"
import script from "./quick-questionsView.vue?vue&type=script&lang=ts&"
export * from "./quick-questionsView.vue?vue&type=script&lang=ts&"
import style0 from "./quick-questionsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
